import { getFeed } from '@/api/feed'

const feed = {
  namespaced: true,
  state: () => ({
    status: {
      items: {
        initialized: false,
        refreshing: false,
        error: false,
      },
    },
    items: [],
  }),
  getters: {
    // getItems: (state) => state.items,
    // isItemsLoaded: (state) => state.status === 'success'
  },
  actions: {
    fetchFeed ({ commit }, url) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'items')
        commit('SET_ERROR_FALSE', 'items')
        getFeed(url)
          .then((items) => {
            commit('SET_INITIALIZED_TRUE', 'items')
            commit('SET_REFRESHING_FALSE', 'items')
            commit('SET_ITEMS', items)
            resolve()
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'items')
            commit('SET_ERROR_TRUE', 'items')
            reject(err)
          })
      })
    },
  },
  mutations: {
    SET_INITIALIZED_TRUE: (state, dataName) => {
      state.status[dataName].initialized = true
    },
    SET_REFRESHING_TRUE: (state, dataName) => {
      state.status[dataName].refreshing = true
    },
    SET_REFRESHING_FALSE: (state, dataName) => {
      state.status[dataName].refreshing = false
    },
    SET_ERROR_TRUE: (state, dataName) => {
      state.status[dataName].error = true
    },
    SET_ERROR_FALSE: (state, dataName) => {
      state.status[dataName].error = false
    },
    SET_ITEMS: (state, payload) => {
      state.items = payload
    },
  },
}

export default feed
